<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="8">
        <v-scroll-y-transition>
          <v-alert v-if="finished" type="success">
            <p><strong>Gratulacje!</strong> Udało Ci się zakończyć kurs.</p>
            Kliknij przycisk <code>Przejdź do wyników</code> poniżej, aby wyświetlić rezultat.
          </v-alert>
        </v-scroll-y-transition>
        <v-card min-height="600">
          <div class="executing-course-tree__treeview">
            <v-treeview
              v-model="selection"
              :items="tree"
              item-key="id"
              return-object
              open-all
              activatable
              :active.sync="active"
              hoverable
            >
              <template v-slot:prepend="{ item }">
                <v-icon :color="item.treeColor">
                  {{ item.icon }}
                </v-icon>
              </template>
              <template v-slot:label="{ item }">
                <div :class="item.treeClass">
                  <v-tooltip bottom dark :disabled="!item.treeColor">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ item.name }}<strong v-if="item.isRequired"> *</strong></span>
                      <template v-if="item.isExecuteable">
                        <v-icon v-if="item.treeColor === 'orange'" class="ml-2" color="orange">
                          mdi-pause-circle-outline
                        </v-icon>
                        <v-icon v-else-if="item.treeColor === 'green'" class="ml-2" color="green">
                          mdi-checkbox-marked-circle-outline
                        </v-icon>
                        <v-icon v-else-if="item.treeColor === 'red'" class="ml-2" color="red">
                          mdi-close-circle-outline
                        </v-icon>
                      </template>
                    </template>
                    <span v-if="item.treeColor === 'orange'">Element niedokończony</span>
                    <span v-else-if="item.treeColor === 'green'">Element zaliczony</span>
                    <span v-else-if="item.treeColor === 'red'">Element niezaliczony</span>
                  </v-tooltip>
                </div>
              </template>
            </v-treeview>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <CourseExecutionExit :finished="finished" />
  </v-container>
</template>

<script>
import CourseExecutionExit from '@/components/course/navigation/CourseExecutionExit.vue';
import UserCourseServiceApi from '@/api/userCourseServiceApi.js';
import { createNamespacedHelpers } from 'vuex';
import MediaApi from '@/api/mediaApi';

const { mapActions } = createNamespacedHelpers('courseExecution');
const { mapState: mapAccountState } = createNamespacedHelpers('account');

export default {
  components: {
    CourseExecutionExit
  },
  props: {
    tree: {
      type: Array,
      required: true
    },
    finished: {
      type: Boolean,
      required: true
    }
  },
  data: function() {
    return {
      selection: [],
      active: []
    };
  },
  computed: mapAccountState(['token']),
  watch: {
    active: 'itemSelected'
  },
  methods: {
    ...mapActions(['selectElementToExecute']),
    async itemSelected(ev) {
      if (!ev || !ev[0]) {
        return;
      }

      const element = ev[0];
      if (!element.isExecuteable) {
        this.active = [];
        return;
      }

      if (element.elementType !== 3) {
        await this.$router.push(`/course/${this.$route.params.courseId}/element/${element.id}`);
      } else {
        try {
          const elementResponse = await new UserCourseServiceApi(this.token).startElementExecution(element.id);
          const elementValue = elementResponse.data.result;
          const definition = JSON.parse(elementValue.execution);

          const { data: file } = await new MediaApi(this.token).get(definition.url);

          await new UserCourseServiceApi(this.token).finishElementExecution(elementValue);
          this.$emit('refreshTree');

          downloadURI(`${file.result.uri}${file.result.sasBlobToken}`);
          this.active = [];
        } catch (e) {
          // TODO: handle
          console.error(e);
        }
      }
    }
  }
};

function downloadURI(uri) {
  const link = document.createElement('a');
  link.href = uri;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
</script>

<style lang="scss">
.executing-course-tree__treeview {
  .v-treeview-node--leaf {
    &:hover {
      cursor: pointer;
    }
  }

  .v-treeview-node__root {
    min-height: 42px;
  }
}
</style>
